import { useState } from 'react';
import { SelectedTabType } from '../types';

export const useSelectedTab = () => {
  const [selectedTab, setSelectedTab] = useState<SelectedTabType>('Alarms');

  const onSelectTabHandler = (tab: SelectedTabType) => {
    setSelectedTab(tab);
  };

  return { selectedTab, onSelectTabHandler };
};
